import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectHasSobCompetitorsChanges = createSelector(
  [selectCompetitorsSobState, selectConfigurationState],
  ({ data, initialData }, { programType }) => {
    return JSON.stringify(data[programType]) !== JSON.stringify(initialData[programType])
  }
)
